export default "/_next/static/images/acda92ce866b8089b04f05f4e17591dc.jpg";